export default {
  None: '',
  PNET: 'PNET',
  ORM: 'ORM',
  EstImage: 'EstImage'
}
